import { usePackageTypes } from '../../../hooks/react-query/use-package-types';
import TypeTab from './type-tab';

function TypeTabContainer() {
  const { isLoading, isError, data: packageTypes } = usePackageTypes();
  if (isError || isLoading || !packageTypes || packageTypes.length < 2) return null;

  return <TypeTab packageTypes={packageTypes} />;
}

export default TypeTabContainer;
